import { Chip, Tooltip } from "@mui/material";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

export const dateFormat = 'DD MM YYYY';
export const datetimeFormat = 'DD MM YYYY, HH:mm';

export const getPatrolLocation = patrol => {

  if(patrol.status.code == 'OFFD' || patrol.status.code == 'BASE') {
    if(patrol.baseLocation && patrol.baseLocation.lat && patrol.baseLocation.lng){
      return patrol.baseLocation;
    }
  } else {
    if(patrol.location && patrol.location.lat && patrol.location.lng){
      return patrol.location;
    }
  }
  return false;
}

export const processAssignments = (patrolsData, tasksData, visibleLines) => {

  const patrolLines = [];
  const taskLines = [];

  const taskMap = new Map(tasksData.map(task => [task.id, task]));
  const patrolsMap = new Map(patrolsData.map(patrol => [patrol.id, patrol]));

  for(const patrolId of visibleLines.patrol) {
    const patrol = patrolsMap.get(patrolId);
    if(!patrol || !Array.isArray(patrol.assignedTasks) || patrol.assignedTasks.length === 0) continue;

    let prevLocation;

    if(patrol.baseLocation && patrol.baseLocation?.lat) {
      prevLocation = patrol.baseLocation;
    }

    if(patrol.location && patrol.location?.lat != null) {
      prevLocation = patrol.location;
    }

    for(const taskId of patrol.assignedTasks) {
      const task = taskMap.get(taskId);

      if(!task || !task.location || !task.location?.lat) continue;

      patrolLines.push([
        {lat: prevLocation.lat, lng: prevLocation.lng},
        {lat: task.location.lat, lng: task.location.lng},
      ]);

      prevLocation = task.location;
    }
  }

  for(const taskId of visibleLines.task) {
    const task = taskMap.get(taskId);
    if(!task || !task.assignedPatrolId || !task.location || !task.location?.lat) continue;

    const patrol = patrolsMap.get(task.assignedPatrolId);
    if(!patrol || (patrol?.location?.lat == null && patrol?.baseLocation?.lat == null)) continue;

    let prevLocation;

    if(patrol.baseLocation && patrol.baseLocation?.lat) {
      prevLocation = patrol.baseLocation;
    }

    if(patrol.location && patrol.location?.lat != null) {
      prevLocation = patrol.location;
    }

    for(const taskId of patrol.assignedTasks) {
      const task = taskMap.get(taskId);

      if(!task || !task.location || !task.location?.lat) continue;

      taskLines.push([
        {lat: prevLocation.lat, lng: prevLocation.lng},
        {lat: task.location.lat, lng: task.location.lng},
      ]);

      prevLocation = task.location;
    }
  }

  return [...patrolLines, ...taskLines];
  

}

export const processAssignments1 = (patrolsData, tasksData, visibleLines) => {
  const taskMap = new Map(tasksData.map(task => [task.id, task]));
  return patrolsData.reduce((assignments, patrol) => {
    if(!patrol.assignedTasks.length) return assignments;
    const endLocations = patrol.assignedTasks.map((id) => {
      const task = taskMap.get(id);
      if(visibleLines.has(patrol?.id) || visibleLines.has(task?.id)) {
        return task ? {"lat": task.location?.lat * 1, "lng": task.location?.lng * 1} : undefined; // * 1 - converts to number
      }

    }).filter(Boolean);

    if (endLocations.length > 0) {
      assignments.push({
        start: patrol.location,
        end: endLocations,
      });
    }
    return assignments;
    
  }, []);
};

export const parseTasks = (tasks, constants) => {
  return tasks.map(task => {
    //const matchedStatus = constants.taskStatus.find(status => status.key == task.status);
    //const matchedTaskType = constants.taskType.find(type => type.id == task.taskType);
    //const matchedFault = constants.faultType.find(fault => fault.key == task.faultId);
    const matchedMake = constants.vehicleMakes?.find(make => make.id == task.vehicleMakeId);
    const matchedModel = constants.vehicleModels?.find(model => model.id == task.vehicleModelId);

    return {
      ...task,
      //taskType: matchedTaskType ? matchedTaskType.key: 'N/A',
      //status: matchedStatus ? matchedStatus.key : 'N/A',
      //faultId: matchedFault ? matchedFault.key: 'N/A',
      vehicleBrand: matchedMake ? matchedMake.label: 'N/A',
      vehicleModel: matchedModel ? matchedModel.name: 'N/A',
    }
  });
}

export const haversineDistance = (lat1, lon1, lat2, lon2) => {
  const toRad = deg => deg * (Math.PI / 180);
  const R = 6371; // Earth radius in kilometers (use 3958.8 for miles)
 
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
 
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
            Math.sin(dLon/2) * Math.sin(dLon/2);
 
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
 
  return R * c; // returns distance in kilometers
}

export const formatDate = (date, uk) => {
  if(!date) return '';
  dayjs.extend(utc);
  dayjs.extend(timezone);

  if(uk) {
    return dayjs.utc(date).tz('Europe/London').format(datetimeFormat);
  } else {
    return dayjs(date).format(datetimeFormat);
  }
}

export const formatBooleanColumns = (value) => {
  return value == '1' ? 'Yes' : 'No';
}

export const formatVehicleBrand = (value, makes) => {
  return makes.find(m => m.id == value).name;
}

export const formatVehicleModel = (value, models) => {
  return models.find(m => m.id == value).name;
}

export const formatFault = (value, vehicleFaults) => {
  return vehicleFaults.find(m => m.id == value).name;
}

export function renderStatus(value, statuses) {
  const colors = {
    "HEAD": 'success',
    "PACK": 'success',
    "COMP": 'success',
    "UNAC": 'default',
    "ARVD": 'default',
    "RECY": "default"
  };
  const parsedStatus = statuses.find(s => s.id == value);
  
  return (
    <Tooltip title={parsedStatus.name} arrow >
      <Chip label={parsedStatus.code} color={colors[parsedStatus.code]} size="small" />
    </Tooltip>
  )
}

export const setDeepValue = (obj, path, value) => {
  const [head, ...rest] = path;
 
  return {
    ...obj,
    [head]: rest.length === 0
      ? value
      : setDeepValue(obj[head] || {}, rest, value)
  };
}

export function renderLocation(location) {
  const { lat, lng } = location || {};
  if (typeof lat === 'number' && typeof lng === 'number') {
    return <a target="_blank" href={`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`}>Open Map</a>
  }
  return <></>;
}
